export const priorityColors = {
  "Low": "text-gray-200 bg-gray-500",
  "Medium": "bg-green-200 text-green-800",
  "High": "bg-blue-200 text-blue-800",
  "Urgent": "bg-yellow-200 text-yellow-800",
};
  
export function getPriorityColor(priority) {
  return priorityColors[priority] || "text-gray-200 bg-gray-500"; // Default fallback
}

export function stripHtml(html) {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
}